import { render } from "./New_McrFooter.vue?vue&type=template&id=4ce11962&scoped=true"
import script from "./New_McrFooter.vue?vue&type=script&lang=js"
export * from "./New_McrFooter.vue?vue&type=script&lang=js"

import "./New_McrFooter.vue?vue&type=style&index=0&id=4ce11962&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce11962"]])

export default __exports__